import { DEFAULT_COMPANY_ROLES } from "@scoach/types";
import { useAuthStore } from "../features/auth/store.ts";

/**
 * Returns the effective selectable roles for the current user and active organization.
 * 1. If custom company roles are defined on the user/auth store or organization, returns those.
 * 2. Otherwise falls back to DEFAULT_COMPANY_ROLES.
 */
export function useAvailableRoles(): readonly string[] {
  const companyRoles = useAuthStore((s) => s.companyRoles);
  const user = useAuthStore((s) => s.user);

  if (Array.isArray(companyRoles) && companyRoles.length > 0) {
    return companyRoles;
  }
  if (Array.isArray(user?.companyRoles) && user.companyRoles.length > 0) {
    return user.companyRoles;
  }
  return DEFAULT_COMPANY_ROLES;
}

/**
 * Non-hook version for synchronous/outside-React contexts.
 */
export function getAvailableRoles(): readonly string[] {
  const state = useAuthStore.getState();
  if (Array.isArray(state.companyRoles) && state.companyRoles.length > 0) {
    return state.companyRoles;
  }
  if (Array.isArray(state.user?.companyRoles) && state.user.companyRoles.length > 0) {
    return state.user.companyRoles;
  }
  return DEFAULT_COMPANY_ROLES;
}
